/* eslint-disable react/prop-types */
import React from 'react';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Icon, NakedButton, Text, Flex, Hide, Box } from 'roo-ui/components';
import { mediaQuery } from '../../../../../../../lib/styledSystem';

export const RoomTypeWrapper = styled(Flex)`
  flex-direction: column;
  flex-wrap: wrap;
  background: ${themeGet('colors.white')};
  border-radius: ${themeGet('radii.default')};
  box-shadow: ${themeGet('shadows.hard')};
  margin-bottom: ${themeGet('space.4')};

  ${mediaQuery.minWidth.sm} {
    flex-direction: row;
    padding: ${themeGet('space.4')};
  }

  ${mediaQuery.minWidth.md} {
    margin-bottom: ${themeGet('space.8')};
    padding: ${themeGet('space.4')} ${themeGet('space.6')};
  }
`;

export const FullWidthHeader = styled(Hide)`
  flex-basis: 100%;
`;

// In tablet + desktop, apply spacing to the bottom of all offers for each room, except the last one
export const OffersWrapper = styled(Box)`
  flex-grow: 1;

  ${mediaQuery.minWidth.md} {
    flex-direction: row;
    margin-left: ${themeGet('space.4')};
  }
`;

export const UnavailableMessage = ({ children }) => (
  <Flex alignItems="center" mt={[1, 0]} mb={[2, 0]}>
    <Text fontWeight="bold" fontSize="base" color="orange" mr={4}>
      {children}
    </Text>
  </Flex>
);

const CurrentImageTextWrapper = styled(Text)`
  position: absolute;
  right: ${themeGet('space.3')};
  bottom: ${themeGet('space.3')};
  color: ${themeGet('colors.white')};
  padding: ${themeGet('space.1')} ${themeGet('space.2')};
  pointer-events: none;
  font-size: ${themeGet('fontSizes.xs')};
  background-color: rgba(34, 34, 34, 0.6);
  border-radius: ${themeGet('radii.default')};
`;

export const CurrentImageText = ({ images, selectedIndex }) => (
  <CurrentImageTextWrapper>
    {selectedIndex + 1} / {images.length}
  </CurrentImageTextWrapper>
);

const GalleryButton = styled(NakedButton)`
  background-color: ${themeGet('colors.white')};
  border-radius: ${themeGet('radii.rounded')};
  z-index: ${themeGet('zIndices.imageGallery')};
  position: absolute;
  opacity: 0.8;
  top: 50%;
  margin-top: -${themeGet('space.4')};
  left: ${(props) => (props.left ? props.left : 'initial')};
  right: ${(props) => (props.right ? props.right : 'initial')};

  &:focus {
    box-shadow: 0 0 0 2pt ${themeGet('colors.blue')};
    outline: 0;
  }

  &:hover,
  &:focus {
    opacity: 1;
  }
`;

export const LeftNav = ({ onClick }) => (
  <GalleryButton left="8px" onClick={onClick}>
    <Icon name="chevronLeft" color="greys.charcoal" title="previous image" size={30} />
  </GalleryButton>
);

export const RightNav = ({ onClick }) => (
  <GalleryButton right="8px" onClick={onClick}>
    <Icon name="chevronRight" color="greys.charcoal" title="next image" size={30} />
  </GalleryButton>
);
